<template>
    <el-upload
            ref="singleImageUploader"
            class="image-uploader"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            accept="image/*"
            :multiple="false"
            :on-change="handleAvatarChange">

        <i v-if="imageUrl != null" class="el-icon-error remove-icon" @click.prevent="onCloseImage"/>
        <img v-if="imageUrl" :src="imageUrl" class="image" alt="">
        <i v-else class="el-icon-plus image-uploader-icon"/>
    </el-upload>
</template>

<script>
    import AlertService from "@/service/alert.service";

    export default {
        name: "SingleImageUploader",
        props: {
            renderImageUrl: String
        },
        data() {
            return {
                imageUrl: this.renderImageUrl,
            }
        },
        watch: {
            renderImageUrl: {
                handler() {
                    this.imageUrl = this.renderImageUrl;
                }
            }
        },
        methods: {
            clearThumbnail() {
                this.imageUrl = null;
                this.$refs["singleImageUploader"].clearFiles();
                this.$emit("update:renderImageUrl", null);
            },
            onCloseImage(evt) {
                this.imageUrl = null;
                this.$emit("update:renderImageUrl", null);
                evt.stopPropagation();
            },
            handleAvatarChange(file, fileList) {
                console.log(file);
                const isValidFormat = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
                const isLt20M = file.raw.size / 1024 / 1024 < 20;

                if (!isValidFormat) {
                    AlertService.error('Avatar picture must be JPG or PNG format!');
                    this.clearThumbnail();
                    return;
                }
                if (!isLt20M) {
                    AlertService.error('Avatar picture size can not exceed 20MB!');
                    this.clearThumbnail();
                    return;
                }
                this.imageUrl = URL.createObjectURL(file.raw);
                this.$emit("update:renderImageUrl", this.imageUrl);
            },
            getImage() {
                let files = this.$refs["singleImageUploader"].uploadFiles;
                return files.length > 0 ? files[files.length - 1].raw : null;
            }
        }
    }
</script>

<style scoped lang="scss">
    /** use /deep/ combinator to add style to child component's classes. **/

    .image-uploader {

        text-align: center;

        /deep/ .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
        }


        /deep/ .el-upload:hover {
            border-color: #409EFF;
        }

        .image-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }

        .image {
            width: 178px;
            height: 178px;
            display: block;
        }

        .remove-icon {
            font-size: 23px;
            position: absolute;
            right: -10px;
            z-index: 1000;
            top: -6px;
            color: #293650 !important;

        }
    }


</style>
